<template>
    <Layout sub="overview">
        <h1>Report Overview</h1>
    </Layout>
</template>

<script setup>
import Layout from "@/Shared/Layout"
</script>
<script>
export default{
    layout: ''
}
</script>
